export enum CommunicationMethod {
    Call = 1,
    SMS = 2,
    Email = 3
}
